import React, { useRef, useEffect, useState, useContext } from 'react';
import { makeStyles, useTheme } from '@mui/styles';
import PropTypes from 'prop-types';
import {
    scaleOrdinal as D3ScaleOrdinal,
    sum as D3sum,
    max as D3max,
    select as D3select,
} from 'd3';
import D3TimelineBarChart from '../../d3/D3TimelineBarChart';
import { GroupsContext } from '../../data/groups-service';
import useWindowSize from '../../libraries/usewindowsize';

const useStyles = makeStyles(theme => ({
    root: {
        fill: theme.ChartColors[0],
        zIndex: theme.zIndex.drawer - 2,
    }
}));

const RIGHT_MARGIN = 260;

const BarChart = ({
    filter,
    data,
    dataservice,
    mouseover,
    onclick,
    height,
    isBT,
}) => {
    const d3Container = useRef(null);
    const classes = useStyles();
    const theme = useTheme();
    const { width } = useWindowSize();
    const [cwidth, setCWidth] = useState(Math.max(width - RIGHT_MARGIN, 10));
    const { groupKeys } = useContext(GroupsContext);

    useEffect(() => {
        /// need to delay sidebar open to avoid wrapping layout
        if (width > cwidth) setTimeout(() => setCWidth(Math.max(width - RIGHT_MARGIN, 10)), 420);
        else setCWidth(Math.max(width - RIGHT_MARGIN, 10));
    }, [width]);

    useEffect(() => {
        const colors = k =>
            D3ScaleOrdinal()
                .range(theme.SeverityColors.concat(theme.ChartColors))
                .domain(groupKeys)(k);
        if (dataservice && d3Container.current) {
            const node = d3Container.current;
            const cdata = data.map(d => {
                if (!filter || !d.groups) return d;
                return { ...d, count: D3sum(d.groups, g => g.key === filter ? g.count : 0) };
            });
            const max = D3max(cdata, d => d.count);
            const g = D3select(node)
                .data([cdata])
                .join('g')
                .call(D3TimelineBarChart()
                    .theme(theme)
                    .dataservice(dataservice)
                    .color(() => filter ? colors(filter) : undefined)
                    .width(cwidth)
                    .height(height)
                    .max(max)
                    .on('mouseover', mouseover)
                    .on('click', onclick));
            g.exit().remove();
        }
    }, [cwidth, dataservice, mouseover, onclick, theme, data, filter, height, groupKeys]);

    return (
        <div
            className={classes.root}
            style={{ fill: isBT ? theme.palette.backtesting.main : theme.ChartColors[0] }}
            name="bar_chart"
            ref={d3Container}>
        </div>
    );
};

BarChart.propTypes = {
    data: PropTypes.array.isRequired,
    height: PropTypes.number,
    dataservice: PropTypes.object,
    filter: PropTypes.string,
    mouseover: PropTypes.func,
    onclick: PropTypes.func,
    isBT: PropTypes.bool,
};

export default BarChart;
